import { render } from "./Pick.vue?vue&type=template&id=2b61c026"
import script from "./Pick.vue?vue&type=script&lang=ts"
export * from "./Pick.vue?vue&type=script&lang=ts"
script.render = render

export default script